export const DEFAULT_LABEL_WIDTH = '260';
export const INITIAL_SESSION_TIMEOUT_SECOND = 1800;
export const LIMITED_SESSION_TIMEOUT_SECOND = 300;
export const XML = 'XML';
export const CIOMS = 'CIOMS';
export const JPN_APPENDIX = 'JPN-APPENDIX';
export const YES = 'Yes';
export const NO = 'No';

export const LABEL_ALIGN = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center'
};

export const WARNING_STATUS = {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE'
};

export const SEARCH_ITME_CONDITION = {
    EQ: 'EQ',
    NOT_EQ: 'NOT_EQ',
    RANGE: 'RANGE',
    LIKE: 'LIKE',
    NOT_LIKE: 'NOT_LIKE',
    NULL: 'NULL',
    NOT_NULL: 'NOT_NULL'
};

export const RECEIVER = {
    EMA: 'EMA',
    MFDS: 'MFDS',
    NMPA: 'NMPA',
    PMDA: 'PMDA',
    FDA: 'FDA'
};

export const MFDS_REPORT_TYPE = 'MFDS_REPORT_TYPE';
export const EU_REPORT_TYPE = 'EU_REPORT_TYPE';
export const NMPA_REPORT_TYPE = 'CASEC_TYPE';
export const PMDA_REPORT_TYPE = 'CASEJ_RPT_TYPE';
export const FDA_REPORT_TYPE = 'FDA_REPORT_TYPE';

/**
 * MFDS Receiver name 속 Report type 라벨에 따른 Report type code 값
 * ex. MFDS(CT)
 */
export const MFDS_REPORT_TYPE_CODE: { [index: string]: any } = {
    'CT': '1',
    'CU': '2',
    'KR': '3',
    'FR': '4',
    'CF': '5',
};

/**
 * FDA R3 Receiver name 속 Report type 라벨에 따른 Report type code 값.
 * ex. FDA(CDER IND)
 */
export const FDA_R3_REPORT_TYPE_CODE: { [index: string]: any } = {
    'CDER IND': '1',
    'CDER IND-exempt BA/BE': '2',
    'CBER IND': '3',
    'Postmarket': '4',
};

export const APPENDIX = {
    ICH: 'NA',
    EMA: 'EU',
    MFDS: 'KR',
    NMPA: 'CN',
    PMDA: 'JP',
    FDA: 'US'
};

export const CASE_REPORT_TYPE_BY_APPENDIX: { [key: string]: string } = {
    KR: MFDS_REPORT_TYPE,
    EU: EU_REPORT_TYPE,
    US: FDA_REPORT_TYPE,
};
